import { render } from "./EFTTermsControl.vue?vue&type=template&id=2bba51fb"
import script from "./EFTTermsControl.vue?vue&type=script&lang=js"
export * from "./EFTTermsControl.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Mobile\\mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__